export default __webpack_public_path__ + "static/media/manual.62f4fbc0.jpg";